/**
 * Location actions
 */
export enum LocationActionEnum {
	/**
	 * Set location record status to 'open'
	 */
	OPEN = 'open',

	/**
	 * Set location record status to 'closed'
	 */
	CLOSE = 'close',

	/**
	 * Assign vehicle to the location record
	 */
	ASSIGN_VEHICLE = 'assign_vehicle',
}
